<template>

  <div class="hello">

      <v-container fluid :style="{ 'min-height': '800px' }">
          <v-container class="contain-width">
<!--              <v-expand-transition>-->
<!--                  <v-banner two-line v-show="expand" class="white rounded mb-6">-->
<!--                      <v-avatar-->
<!--                              slot="icon"-->
<!--                              color="deep-purple accent-4"-->
<!--                              size="40"-->
<!--                      >-->
<!--                          <v-icon-->
<!--                                  color="white"-->
<!--                          >-->
<!--                              mdi-card-account-details-->
<!--                          </v-icon>-->
<!--                      </v-avatar>-->

<!--                      <p class="text-subtitle-1">Become a member to get lots of benefits</p>-->

<!--                      <template v-slot:actions>-->
<!--                          <v-btn rounded dark color="deep-purple accent-4" class="small">Read more</v-btn>-->
<!--                      </template>-->
<!--                  </v-banner>-->
<!--              </v-expand-transition>-->
              <h1 class="mt-6 mb-6">Members shop</h1>
            <p class="intro mb-12">After you have subscribed to <i>findmykit</i> and become a member, you will have full access to purchase items from our Members Shop. These can be extra items you might need in addition to your <strong>FREE bundle</strong>, or completely new items such as <router-link
                :to="{ name: 'product', params: {slug: 'golf-bag-tags-non-personalised'} }">Golf Tags</router-link> or our popular <router-link
                :to="{ name: 'product', params: {slug: 'findmykid-id-bracelet'} }">Findmykid ID Bracelet</router-link>.</p>
              <v-row v-if="!authenticated || (authenticated && !user.bundle_claimed_at && !hasActiveTrial && !user.membership)">
                  <v-col cols="12">
                    <v-hover>
                      <template v-slot="{ hover }">
                      <v-card
                              class="mx-auto"
                              style="border-radius: 15px"
                              outlined
                              :elevation="hover ? 4 : 2"
                      >
                          <v-card-text>
                            <h2 class="h2 mb-6 headline primary--text">Get your subscription and claim your FREE bundle</h2>

                            <p class="h3 mt-0 mb-6">You must have an active subscription to receive alerts, purchase new products, or activate tags.</p>

                            <h3 class="mt-3 mb-6 text-h6">Your £25 yearly subscription includes:</h3>

                            <!--            <h3 class="h3 mb-6">Your £25 yearly subscription includes:</h3>-->
                            <!--            <h3 class="h3 mb-6">Your £25 yearly subscription includes:</h3>-->

                            <v-row>
                              <v-col md="3" offset-md="1">
                                <ul class="products-list">
                                  <li :class="product === 0 ? 'primary--text' : ''">25 Iron on labels <v-icon v-if="product === 0" color="primary" size="30">mdi-chevron-right</v-icon></li>
                                  <li :class="product === 1 ? 'primary--text' : ''">25 Sticker labels <v-icon v-if="product === 1" color="primary" size="30">mdi-chevron-right</v-icon></li>
                                  <li :class="product === 2 ? 'primary--text' : ''">3 Key tags <v-icon v-if="product === 2" color="primary" size="30">mdi-chevron-right</v-icon></li>
                                  <li :class="product === 3 ? 'primary--text' : ''">1 two part bag tag <v-icon v-if="product === 3" color="primary" size="30">mdi-chevron-right</v-icon></li>
                                  <li :class="product === 4 ? 'primary--text' : ''">1 Recovery card <v-icon v-if="product === 4" color="primary" size="30">mdi-chevron-right</v-icon></li>
                                </ul>
                              </v-col>
                              <v-col md="6">
                                <v-carousel
                                    v-model="product"
                                    cycle
                                    interval="5000"
                                    :show-arrows="false"
                                    hide-delimiters
                                    height="300"
                                    light
                                    continuous
                                >
                                  <v-carousel-item key="product-1" transition="fade-transition">
                                    <v-img
                                        :src="require('@/assets/product-iron-on.png')"
                                        cover
                                        alt="Iron on labels"
                                    ></v-img>
                                  </v-carousel-item>
                                  <v-carousel-item key="product-2" transition="fade-transition">
                                    <v-img
                                        :src="require('@/assets/product-sticker.png')"
                                        cover
                                        alt="Sticker labels"
                                    ></v-img>
                                  </v-carousel-item>
                                  <v-carousel-item key="product-3" transition="fade-transition">
                                    <v-img
                                        :src="require('@/assets/product-key-tags.png')"
                                        cover
                                        alt="Key tags"
                                    ></v-img>
                                  </v-carousel-item>
                                  <v-carousel-item key="product-4" transition="fade-transition">
                                    <v-img
                                        :src="require('@/assets/product-2-part-bag-tag.jpg')"
                                        cover
                                        alt="2 part bag tag"
                                    ></v-img>
                                  </v-carousel-item>
                                  <v-carousel-item key="product-5" transition="fade-transition">
                                    <v-img
                                        :src="require('@/assets/product-recovery-card-3d.png')"
                                        cover
                                        alt="Recovery card"
                                    ></v-img>
                                  </v-carousel-item>
                                </v-carousel>

                              </v-col>
                            </v-row>
<!--                            <div class="text-center mt-6">-->
<!--                              <v-btn v-if="authenticated && !!user.stripe_subscription === false" x-large elevation="0" color="primary" @click="membershipDialog = true" class="mr-12 ml-12">{{ $t('buttons.Subscribe now') }}</v-btn>-->
<!--                              <v-btn v-if="authenticated && !user.bundle_claimed_at" x-large elevation="0" dark color="primary" @click="navigate('basket')" class="mr-12 ml-12">{{ $t('buttons.Claim free bundle now') }}</v-btn>-->
<!--                              <v-btn v-if="!authenticated" rounded elevation="0" color="primary" x-large @click="navigate('sign-up-individual')" class="mr-6 ml-6">Sign me up</v-btn>-->
<!--                              <v-btn v-if="!authenticated" rounded elevation="0" color="primary" x-large @click="navigate('login')" class="mr-6 ml-6">Add subscription</v-btn>-->
<!--                            </div>-->
<!--                              <v-row>-->
<!--                                  <v-col class="col-12 col-md-6">-->
<!--                                      <h1 class="headline primary&#45;&#45;text">{{ $t('headings.Get your subscription and claim your FREE bundle') }}</h1>-->
<!--                                      <h2 class="text-subtitle-1 mt-3 mb-6">{{ $t("You must have an active subscription to receive alerts, purchase new products, or activate tags") }}.</h2>-->

<!--                                    <IndividualsSummary/>-->

<!--                                  </v-col>-->
<!--                                  <v-col class="col-12 col-md-6 text-right">-->
<!--                                      <v-img contain class="mt-4 mr-6"-->
<!--                                             src="https://findmykit-images.s3-eu-west-1.amazonaws.com/personal-bundle.png"></v-img>-->
<!--                                  </v-col>-->
<!--                              </v-row>-->
                          </v-card-text>





                          <v-card-actions class="d-flex flex-row justify-md-start justify-center flex-wrap">
                            <v-btn v-if="authenticated && !!user.stripe_subscription === false" x-large elevation="0" color="primary" @click="membershipDialog = true" class="pr-6 pl-6 mb-3 mb-md-0">{{ $t('buttons.Subscribe now') }}</v-btn>
                            <v-btn v-if="authenticated && !user.bundle_claimed_at" x-large elevation="0" dark color="primary" @click="navigate('basket')" class="pr-6 pl-6 mb-3 mb-md-0">{{ $t('buttons.Claim free bundle now') }}</v-btn>
                            <v-btn v-if="!authenticated" rounded elevation="0" color="primary" x-large @click="navigate('sign-up-individual')" class="pr-6 pl-6 mr-3 ml-3 mb-3 mb-md-0">Sign me up</v-btn>
                            <v-btn v-if="!authenticated" rounded elevation="0" color="primary" x-large @click="navigate('login')" class="pr-6 pl-6 mr-3 ml-3 mb-3 mb-md-0">Add subscription</v-btn>

                          </v-card-actions>


                      </v-card>
                      </template>
                    </v-hover>
                  </v-col>
              </v-row>
              <v-row v-if="show">
                  <v-col
                          v-for="product in products"
                          :key="'product-' + product.id"
                          cols="12"
                          sm="6"
                          md="4"
                  >
                      <v-hover>
                          <template v-slot="{ hover }">
                              <v-card
                                      class="mx-auto product-card"
                                      outlined
                                      :elevation="hover ? 4 : 2"
                              >
                                  <v-card-title class="headline primary--text">{{product.name}}</v-card-title>

                                  <div v-if="product.product_images.length > 0" class="white">
                                    <v-img

                                        class="white--text align-end"
                                        height="300px"
                                        :src="product.product_images[0].path"
                                    >
                                      <v-overlay
                                          v-if="product.coming_soon"
                                          :absolute="true"
                                          :value="true"
                                          :opacity="0.5"
                                      >
                                        <p class="title white--text"><v-icon left large dark color="white">mdi-bullhorn</v-icon> {{ $t("Coming soon") }}</p>
                                      </v-overlay>
                                    </v-img>
                                  </div>

                                  <v-card
                                          v-else
                                          :color="`grey lighten-4`"
                                          class="px-3 pt-3 pb-3"
                                          flat
                                          rounded
                                  >
                                      <v-skeleton-loader
                                              class="mx-auto"
                                              height="276"
                                              type="image"
                                      ></v-skeleton-loader>
                                      <v-overlay
                                              :absolute="true"
                                              :value="true"
                                              :opacity="0"
                                      >
                                          <p class="title black--text"><v-icon left large color="black">mdi-bullhorn</v-icon> {{ $t("Image coming soon") }}</p>
                                      </v-overlay>
                                  </v-card>

                                  <v-card-text class="text--primary">

                                      <p class="font-weight-black subtitle-1" v-if="product.enabled">{{ brand === 'neotag' ? '€' : '£'}}{{product.price}}</p>

                                      <div class="body-1">{{truncate(product.description, 100)}}</div>

                                      <p class="text-right mt-2">
                                          <router-link
                                                  :to="{ name: 'product', params: {slug: product.slug} }"
                                          >{{ $t('links.Read more') }}</router-link>
                                      </p>

                                      <p class="mt-6" v-if="product.personalisable">{{ $t("Personalised products will be posted separately within 6/8 weeks") }}.</p>

                                      <p class="mt-6" v-if="product.id === 3 || product.id === 4">{{ $t("Available for dispatch immediately") }}.</p>

                                  </v-card-text>

                                  <v-card-actions class="d-flex justify-space-between align-end" style="width: 100%">
                                      <v-btn v-if="product.coming_soon" rounded disabled class="small" elevation="0" color="primary" @click="addToBasket(product)">
                                          <v-icon left>add_shopping_cart</v-icon> {{ $t("Coming soon") }}
                                      </v-btn>
                                      <v-btn v-else class="small" elevation="0" rounded color="primary" @click="addToBasket(product)">
                                          <v-icon left>add_shopping_cart</v-icon> {{ $t('buttons.Add to basket') }}
                                      </v-btn>
                                      <v-img
                                              v-if="product.activate == 1"
                                              class="white--text"
                                              max-width="80px"
                                              :src="activ8Logo"
                                              eager
                                      >
                                      </v-img>
                                  </v-card-actions>
                              </v-card>
                          </template>
                      </v-hover>
                  </v-col>
              </v-row>
              <v-row v-else>
                  <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-for="item in 6"
                          v-bind:key="item"
                  >
                      <v-sheet
                              :color="`grey lighten-4`"
                              class="px-3 pt-3 pb-3"
                      >
                          <v-skeleton-loader
                                  class="mx-auto"
                                  max-width="300"
                                  type="card"
                          ></v-skeleton-loader>
                      </v-sheet>
                  </v-col>
              </v-row>

              <v-dialog
                      v-model="membershipDialog"
                      max-width="600"
              >
                  <v-card>
                      <v-card-title class="headline primary">
                          {{ $t('headings.Subscription') }}
                      </v-card-title>

                      <v-card-text>
                          <MembershipForm v-on:close-form="closeForm"/>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                                  color="primary"
                                  text
                                  @click="membershipDialog = false"
                          >
                              {{ $t('buttons.Close') }}
                          </v-btn>
                      </v-card-actions>
                  </v-card>

              </v-dialog>

          </v-container>
      </v-container>
      <Footer />
  </div>

</template>

<script>

    // import IndividualsSummary from "./IndividualsSummary";
    let product1 = require('@/assets/IMG_3382.jpg')

    import axios from 'axios';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Footer from './Footer.vue'
    import MembershipForm from './MembershipForm'
    import {i18n} from "../i18n";

    export default {
        name: 'Shop',
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Shop'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Shop for personalised iron on or sticker tags to find your lost property') + '.' + i18n.t('Bag tags, Recovery card, Luggage insert, Key tags Golf bag tags, business card') }
            ]
          }
        },
        components: {
            'Footer': Footer,
            'MembershipForm': MembershipForm
        },
        // props: {
        //   title: String
        // },
        data () {
            return {
                placeholder: product1,
                products: [],
                show: false,
                hover: false,
                expand: false,
                membershipDialog: false,
                reveal: false,
                product: 0,
            }
        },
        mounted () {

            window.scrollTo(0,0);

            this.loadProducts()
        },
        watch: {
          locale (to, from){
            if (to !== from) {
              this.loadProducts()
            }
          }
        },
        methods: {
            ...mapActions('basket', ['add']),
            loadProducts() {
              this.show = false

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': this.locale},
              });

              instance
                  .get('/api/products/enabled?brand=' + this.brand)
                  .then(response => {
                    this.products = response.data.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
                  .finally(() => {
                    this.show = true
                    this.expand = true
                    window.prerenderReady = true;
                  })
            },
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            addToBasket(product) {
                if (this.hasMembership || this.hasActiveTrial) {
                    return this.add({product}).then(() => {
                        console.log('add')
                    })
                }
                else {
                    //this.$router.push({name: 'membership'})
                    this.membershipDialog = true
                }
            },
            navigate(route, params) {
                this.$router.push({name: route, params: params})
            },
            truncate (description, length) {
                if (description.length > length) {
                    return description.substring(0, length) + '...';
                } else {
                    return description;
                }
            },
            closeForm() {
                this.membershipDialog = false
            }
        },
        computed: {
            ...mapGetters('account', ['hasMembership', 'hasActiveTrial']),
            ...mapState({
                authenticated: state => state.authenticated,
                user: state => state.account.user,
                brand: state => state.brand,
                brandName: state => state.brandName,
                locale: state => state.locale
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            activ8Logo() {
              if (this.brand === 'neotag') {
                return require('@/assets/activ8-logo-alpha-dark.png')
              }
              return require('@/assets/activ8-logo.png')
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
      margin: 40px 0 0;
    }
    ul {
      list-style-type: none;
      padding: 0;
    }
    li {
      display: inline-block;
      margin: 0 10px;
    }
    a {
      color: #42b983;
    }
    .product-card {
        border-radius: 15px;
        border: none !important;
        height: 100%;
        padding-bottom: 60px;
    }
    .product-card .v-card__actions {
        padding-left: 15px;
        padding-bottom: 15px;
        position: absolute;
        bottom: 0;
    }
    .product-card .headline {
        font-size: 1.4rem !important;
    }

    .title-back {
        background-color:rgba(0,0,0,0.4)
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .8s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .products-list li {
      font-size: 1.6rem;
      line-height: 2.5rem;
      font-family: "Open Sans", sans-serif;
      font-weight: 300;
    }
</style>
